import { yieldToMain } from '@/root/utils/yield-to-main'
import classNames from 'classnames'
import React from 'react'

export interface TimePeriodSeriesProps {
  timePeriodsInMonths: Array<number> | Array<string> //e.g [1,3,6,12,36]
  onTimePeriodSelected?: (months: number | string) => void
  selected?: number | string
  variant?: 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'quinary'
  className?: string
}

const getMonthsInText = (months: number | string): number | string => {
  switch (months) {
    case -1:
      return '1D'
    case -7:
      return '1W'
    case 1:
      return '1M'
    case 6:
      return '6M'
    case 12:
      return '1Y'
    case 36:
      return '3Y'
    case 60:
      return '5Y'
    case 120:
      return '10Y'
    default:
      return months
  }
}
const TimePeriodSeries = ({
  timePeriodsInMonths,
  onTimePeriodSelected,
  selected,
  variant = 'primary',
  className,
}: TimePeriodSeriesProps) => {
  const onTimePeriodSelectedClick = async (months: number | string) => {
    await yieldToMain()
    if (onTimePeriodSelected) onTimePeriodSelected(months)
  }
  const getButton = (months: number | string, isHighlighted: boolean) => {
    return (
      <p
        className={classNames({
          'rounded-3xl border bg-blue-500 px-3 py-1 text-white':
            variant != 'quaternary' && variant != 'quinary' && isHighlighted,
          'px-3 py-1 text-gray-600': !isHighlighted,
          'bg-brand-grey-background rounded-3xl':
            variant === 'secondary' && !isHighlighted,
          'border-brand-blue-azureRadiance !text-brand-blue-azureRadiance rounded-3xl border bg-white':
            variant === 'tertiary' && !isHighlighted,
          'text-brand-blue-azureRadiance bg-brand-tertiary-blue rounded-lg px-3 py-1 text-sm font-normal':
            variant === 'quaternary' && isHighlighted,
          'bg-brand-tertiary-grey rounded-lg text-sm font-normal':
            variant === 'quaternary' && !isHighlighted,
          'border-1 border-brand-blue-azureRadiance rounded-[20px] px-3 py-0.5 text-sm font-normal':
            variant === 'quinary' && isHighlighted,
          'mx-1': variant !== 'quinary',
        })}
        onClick={() => {
          if (!isHighlighted) onTimePeriodSelectedClick(months)
        }}
      >
        {getMonthsInText(months)}
      </p>
    )
  }

  const getButtons = () => {
    const length = timePeriodsInMonths.length

    return timePeriodsInMonths.map((month, i) => {
      return (
        <div
          className={classNames('text-13px cursor-pointer font-medium', {
            '!mr-3': length <= 3,
          })}
          key={i}
        >
          {getButton(month, month === selected)}
        </div>
      )
    })
  }

  const buttonJsx = getButtons()

  return (
    <div
      className={classNames(
        'no-scrollbar my-3 flex justify-between overflow-auto',
        className,
        {
          '!justify-center': buttonJsx.length <= 3,
        },
      )}
    >
      {buttonJsx}
    </div>
  )
}

export default React.memo(TimePeriodSeries)
